export const MAPBOX_SRC = 'https://api.mapbox.com/mapbox-gl-js/v2.14.1/mapbox-gl.js'
export const MAPBOX_CSS = 'https://api.mapbox.com/mapbox-gl-js/v2.14.1/mapbox-gl.css'
export const MAPBOX_DRAW_SRC = 'https://unpkg.com/@mapbox/mapbox-gl-draw@1.4.3/dist/mapbox-gl-draw.js'
export const MAPBOX_DRAW_CSS = 'https://unpkg.com/@mapbox/mapbox-gl-draw@1.4.3/dist/mapbox-gl-draw.css'
export const STRIPE_SRC = 'https://js.stripe.com/v3/'

export const addTrackingScriptsIfProduction = () => {
  // Use requestIdleCallback to load non-critical scripts only when the main thread is free.
  // Fallback to setTimeout if requestIdleCallback is not valid (e.g. Safari < 2023, though getting rare) or just simple delay.
  const loadScripts = () => {
    console.log('[DEBUG] Adding tracking scripts (lazy)')
    addScriptSrcToPage(STRIPE_SRC)
  }

  if ('requestIdleCallback' in window) {
    requestIdleCallback(
      () => {
        loadScripts()
      },
      { timeout: 3000 }
    )
  } else {
    // Fallback for browsers that don't support requestIdleCallback
    setTimeout(loadScripts, 500)
  }
}

export const addScriptToPage = (scriptContentAsString) => {
  console.log('[DEBUG] Adding script to page')
  const script = document.createElement('script')
  script.type = 'text/javascript'
  script.innerHTML = scriptContentAsString

  document.head.appendChild(script)
}

export const addScriptSrcToPage = (scriptSrc, isModule = false, tags = {}) => {
  console.log(`[DEBUG] Adding script src to page: ${scriptSrc}`)
  const script = document.createElement('script')
  script.src = scriptSrc
  if (isModule) {
    script.type = 'module'
  }
  for (const key of Object.keys(tags)) {
    script[key] = tags[key]
  }
  document.head.appendChild(script)
}

export const addStyleSrcToPage = (styleSrc) => {
  console.log(`[DEBUG] Adding style src to page: ${styleSrc}`)
  const style = document.createElement('link')
  style.setAttribute('href', styleSrc)
  style.setAttribute('rel', 'stylesheet')
  document.head.appendChild(style)
}
